exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vbt-autcomplete-list[data-v-a0e87de4]{padding-top:5px;position:absolute;max-height:350px;overflow-y:auto;z-index:999}", "", {"version":3,"sources":["D:/xampp/htdocs/open_house/ui/node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue"],"names":[],"mappings":"AACA,uCACE,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,gBAAiB,AACjB,WAAa,CACd","file":"VueBootstrapTypeahead.vue","sourcesContent":["\n.vbt-autcomplete-list[data-v-a0e87de4] {\n  padding-top: 5px;\n  position: absolute;\n  max-height: 350px;\n  overflow-y: auto;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0e87de4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue
// module id = 295
// module chunks = 3 4